/**
 *  @fileOverview Scroll To module
 *
 *  @author       Aaron Chapman
 *
 */

function ScrollToModule () {
  this.scrollTo = function (event) {
    event.preventDefault()
    let scrollTarget = document.querySelector(event.target.hash)
    let mobileoset = 0
    let headeroset = 0
    const aside = document.querySelector('.aside')
    const header = document.querySelector('.header')
    let top = 0

    if (typeof header !== 'undefined' && header !== null) {
      header.classList.add('header--scrolled')

      if (typeof aside !== 'undefined' && aside !== null) {
        if (aside.offsetLeft > 0) {
          headeroset = header.offsetHeight
        }
      }
    }

    /**
     * Account for height of internal nav if it isn't sitting on the right hand side eg full screen
     */
    if (typeof aside !== 'undefined' && aside !== null) {
      if (aside.offsetLeft === 0) {
        mobileoset = aside.offsetHeight + aside.offsetHeight
      }
    }

    const viewportOffset = scrollTarget.getBoundingClientRect()
    if (viewportOffset !== null) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      top = viewportOffset.top + scrollTop - headeroset

      window.scroll({
        top: top - mobileoset,
        left: 0,
        behavior: 'smooth'
      })

      document.activeElement = scrollTarget
    }
  }

  this.init = function () {
    /**
     * Check if testimonials section has been rendered by funnelback
     * Remove link from aside if not found
     */
    const testimonials = document.querySelector('#testimonials')

    if (typeof testimonials === 'undefined' || testimonials === null) {
      const aside = document.querySelector('.aside')

      if (aside !== null) {
        const link = aside.querySelector('a[href="#testimonials"]')

        if (link !== null) {
          link.parentElement.remove()
        }
      }
    }

    let anchors = document.querySelectorAll('a[href^="#"]')

    Array.from(anchors).forEach(anchor => {
      /**
       * Ignore toggle hrefs
       */
      if (anchor.href.indexOf('#toggle-') === -1 && anchor.href.indexOf('#vue-dropdown') === -1 && anchor.classList.contains('button--entryPathwayLeadGen') === false) {
        anchor.addEventListener('click', this.scrollTo, false)
      }
    })
  }
}

module.exports = ScrollToModule
